// extracted by mini-css-extract-plugin
module.exports = {"item":"GalleryMasonryList_item__3UgDQ","box":"GalleryMasonryList_box__8xCow"};